import { render, staticRenderFns } from "./Wish.vue?vue&type=template&id=273ec1fa&scoped=true&"
import script from "./Wish.vue?vue&type=script&lang=js&"
export * from "./Wish.vue?vue&type=script&lang=js&"
import style0 from "./Wish.vue?vue&type=style&index=0&id=273ec1fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ec1fa",
  null
  
)

export default component.exports